module.exports = __webpack_public_path__ + "img/864-645696.png";